import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=52a97e10&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"
import style0 from "./navbar.vue?vue&type=style&index=0&id=52a97e10&prod&lang=scss&scoped=true"
import style1 from "./navbar.vue?vue&type=style&index=1&id=52a97e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a97e10",
  null
  
)

export default component.exports